import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { catalogService } from "../../services";
import { SkeletonGrid } from "../../components/ui";

export default function PromotionList() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.promotions().then((data) => alive && setRows(data || []));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <PageBanner title="โปรโมชั่น" breadcrumb={[{ label: "โปรโมชั่น" }]} seed={5} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        {rows === null ? (
          <SkeletonGrid count={6} height={320} className="lt-promo-grid" />
        ) : (
          <div className="lt-promo-grid">
            {rows.map((promo) => (
              <article className="lt-promo" key={promo.id}>
                <img className="lt-promo__cover" src={promo.cover} alt={promo.title} loading="lazy" />
                <div className="lt-promo__body">
                  <div className="lt-promo__title">🌈 {promo.title}</div>
                  <div className="lt-promo__meta">Update {promo.updatedAt}</div>
                  <p className="lt-helper">{promo.excerpt}</p>
                  <Link to={`/promotions/detail/${promo.id}`} className="lt-btn lt-btn--ghost lt-btn--pill">
                    อ่านเพิ่มเติม
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
